export const frameworkLabels = {
  next: "Next.js",
  nuxt: "Nuxt",
  sveltekit: "SvelteKit",
  other: "Other",
} as const

export const frameworkCreateProjectCodeSnippet = {
  next: "npx create-next-app@latest",
  nuxt: "npx nuxi@latest init",
  sveltekit: "npx sv create",
} as const
